import { clsx } from 'clsx'
import { Button } from 'component/Button'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useBodyScrollLock } from 'hook/useBodyScrollLock'
import { useClickOutside } from 'hook/useClickOutside'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { CombinePane } from 'page/catalog/combo/CombinePane'
import { FilterAccordion } from 'page/catalog/FilterAccordion/FilterAccordion'
import css from 'page/catalog/FiltersDrawer/FiltersDrawer.module.scss'
import { PriceAccordion } from 'page/catalog/price/PriceAccordion'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { useState } from 'react'

export const FiltersDrawer = observer(() => {
  const demo = useDemo()
  const { stand, basic, tsum, options, form } = demo
  const { combineFilter } = demo.product
  const [closing, setClosing] = useState(false)

  const {
    brands,
    styles,
    categories,
    colors,
    tsum_categories,
    tsum_seasons,
    tsum_sizes,
    price_filter,
  } = options

  useBodyScrollLock(true)

  const close = useLatestCallback(() => {
    setClosing(true)
    setTimeout(() => demo.drawer = false, 200)
  })

  const onOutside = useClickOutside(() => {
    close()
  })

  const onClose = useLatestCallback(() => {
    close()
    form.reset()
  })

  const onReset = useLatestCallback(() => {
    close()
    form.clear()
  })

  const onApply = useLatestCallback(() => {
    close()
    form.refresh()
  })

  return <Vertical ref={onOutside} className={clsx(css.drawer, closing && css.closing)}>
    <Space gap={[4, 12]} pad={[12, 16]} opposite wrap>
      <Space>
        <Button pad={0} action={onClose}>
          <Space gap={8}>
            <Icon name="arrow_back" size={16} />
            <Typo medium upper>{i18n('GoBack')}</Typo>
          </Space>
        </Button>
      </Space>
      <Space height={32} center>
        <Typo size={tsum ? 17 : 13} medium upper accent>
          {i18n('Filters')}
        </Typo>
      </Space>
      <Space>
        <Button pad={0} action={onReset}>
          {i18n('Reset')}
        </Button>
      </Space>
    </Space>

    <Vertical flex="1 1 0" scroll>
      {brands && <FilterAccordion filter={form.brands} options={brands} />}
      {styles && <FilterAccordion filter={form.styles} options={styles} />}
      {categories && <FilterAccordion filter={form.categories} options={categories} />}
      {tsum_categories && <FilterAccordion filter={form.categories} options={tsum_categories} />}
      {colors && <FilterAccordion filter={form.colors} options={colors} />}
      {tsum_seasons && <FilterAccordion filter={form.seasons} options={tsum_seasons} />}
      {tsum_sizes && <FilterAccordion filter={form.sizes} options={tsum_sizes} />}
      {price_filter && !stand && <PriceAccordion />}
      {combineFilter && !basic && <CombinePane />}
    </Vertical>

    <Space pad={16}>
      <Button primary wide height={48} action={onApply}>
        {i18n('Apply')}
      </Button>
    </Space>
  </Vertical>
})
